module.exports = __webpack_public_path__ + "img/user.3ed95c69.gif";